import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "../lib/api";

let lastTracked = "";

export default function PageTracker() {
  const loc = useLocation();
  useEffect(() => {
    const path = loc.pathname;
    if (path === lastTracked) return;
    lastTracked = path;
    api.post("/track", { path }).catch(() => {});
  }, [loc.pathname]);
  return null;
}
